/**
 * Column definitions, mirrored from the API's field dictionary
 * (qcomm-blinkit-api/src/query/fieldDictionary.ts) and the availability
 * knowledge document, so the dashboard and the MCP describe a metric the
 * same way.
 */
export interface FieldHelp {
  text: string;
  formula?: string;
}

export const FIELD_HELP: Record<string, FieldHelp> = {
  psl: {
    text: 'Potential sales loss — revenue given away because the SKU was not on shelf. Banded on the loss rate, not the rupee amount, so a large SKU is not automatically High.',
    formula: 'PSL / (realised sales + PSL)',
  },
  wt_osa: {
    text: 'Sales-weighted on-shelf availability: each SKU’s OSA weighted by its share of sales, so the big sellers move the number. At single-SKU grain this is the raw OSA — there is nothing to weight against.',
    formula: 'Σ(OSA × sales) / Σ sales',
  },
  listing: {
    text: 'Share of live dark stores where the SKU is listed, on the latest observed day. Listing is presence on the shelf plan; OSA is whether it was actually in stock.',
    formula: 'Σ listed stores / Σ live stores',
  },
  osa_ls: {
    text: 'Availability measured only across the stores where the SKU is listed. Higher than Wt OSA% because stores that never carried it are excluded.',
    formula: 'Σ in-stock observations / Σ listed observations',
  },
  doi: {
    text: 'Days of inventory — how long current stock lasts at the current run rate. Pooled as total stock over total daily depletion.',
    formula: 'Σ inventory / Σ (units sold / selling days)',
  },
  soh: {
    text: 'Stock on hand: crawl-estimated units across the scope on the latest observed day.',
  },
};
